var render, staticRenderFns
import script from "./new-table.vue?vue&type=script&lang=js"
export * from "./new-table.vue?vue&type=script&lang=js"
import style0 from "./new-table.vue?vue&type=style&index=0&id=60d214e1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d214e1",
  null
  
)

export default component.exports